const MODES = {
  autocomplete: 1,
  fullSearchResults: 2,
  categoryItems: 3,
}

export default MODES
